import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yanjing",
  "use": "icon-yanjing-usage",
  "viewBox": "0 0 1026 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1026 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yanjing\"><path d=\"M1011.2 499.2C821.76 279.04 629.76 176.64 442.88 197.12 171.52 222.72 15.36 494.08 10.24 504.32l-7.68 12.8 7.68 12.8c7.68 10.24 163.84 281.6 432.64 307.2 15.36 2.56 28.16 2.56 43.52 2.56 174.08 0 350.72-102.4 524.8-304.64l15.36-15.36-15.36-20.48z m-499.2 153.6c-76.8 0-138.24-61.44-138.24-138.24s61.44-138.24 138.24-138.24 138.24 61.44 138.24 138.24-61.44 138.24-138.24 138.24z\" fill=\"\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol